module.exports = __webpack_public_path__ + "static/media/13.fd6e29ff.png";